import axios from '../Axios/Default';
import { handleResponse, getMultipartOptions } from './HelperService';

const getUsers = (params, onSuccess, onError) => {
    const response = axios.get(`/api/v1/admin/user`, {params});
    return handleResponse(response, onSuccess, onError);
};

const getUserById = (id, onSuccess, onError) => {
    const response = axios.get(`api/v1/admin/user/${id}`);
    return handleResponse(response, onSuccess, onError);
};

const createUser = (payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/admin/user`, payload, getMultipartOptions(axios));
    return handleResponse(response, onSuccess, onError);
};

const updateUser = (username, payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/admin/user/${username}`, payload, getMultipartOptions(axios));
    return handleResponse(response, onSuccess, onError);
};

const softDeleteUser = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/user/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

const getUserIdentity = (payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/admin/verify/identity`, {email: payload});
    return handleResponse(response, onSuccess, onError);
};

const resetPassword = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/user/${id}/reset`, payload);
    return handleResponse(response, onSuccess, onError);
};


export { getUsers, getUserById, createUser, updateUser, softDeleteUser, getUserIdentity, resetPassword };